module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-italic-ebb76d66c9db5d68f10fd863857a3e2c.svg";